import { z } from "zod";

import { isSupportedCurrency } from "../currency/currencies";
import { ALLOWED_CURRENCIES } from "./money";

// Kept separate from `money.ts` so the pure `Money` value object and
// `exponentOf` helper can be imported without dragging zod into the bundle.

export const currencyCodeSchema = z
  .string()
  .regex(/^[A-Z]{3}$/, "Currency code must be exactly 3 uppercase letters")
  .refine(isSupportedCurrency, { message: "Unsupported currency code" });

export const moneyDtoSchema = z.object({
  amount: z.number().int().nonnegative().max(100_000_000_00),
  currencyCode: z
    .string()
    .transform((s) => s.toUpperCase())
    // Spread to mutable tuple — z.enum requires [string, ...string[]] in Zod v4
    .pipe(z.enum([...ALLOWED_CURRENCIES] as [string, ...string[]])),
});

export type MoneyDto = z.infer<typeof moneyDtoSchema>;
